import React, { useEffect, useState } from "react";
import "./styles.css";
//external-components
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha, Paper, Typography, Box } from "@mui/material";
import InputBase from "@mui/material/InputBase";
import { colors } from "../../common/pallette/colors";
import { useDispatch, useSelector } from "react-redux";
import { setAdminPageSearchString, setGoalsSearchString } from "../../redux/reducers/common";
import { setEvaluationSearchString } from "../../redux/reducers/evaluation";
import { setEvaluationDashboardSearchString } from "../../redux/reducers/evaluationDashboard";
import { setActionsSearchString, setProjectsSearchString } from "../../redux/reducers/actionPlan";
import { setArchivedLibrarySearchString, setCurrentLibrarySearchString } from "../../redux/reducers/library";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: colors.grey.light,
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.black, 0.25),
  },
  marginLeft: 0,
  marginRight: "10px",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 1.5),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  fontSize: "14px",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    //   paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    paddingLeft: `40px`,
    transition: theme.transitions.create("width"),
    width: "100%",
    height: "100%",
  },
}));

const SearchBox = (props: any) => {
  const { searchBoxStyle, placeholder, parent } = props;
  const dispatch = useDispatch();
  const adminPageSearchString = useSelector(
    (state: any) => state.common.adminPageSearchString
  );
  const evalPageSearchString = useSelector(
    (state: any) => state.evaluation.searchString
  );
  const evalDashPageSearchString = useSelector(
    (state: any) => state.evaluationDashboard.searchString
  );
  const goalsSearchString = useSelector(
    (state: any) => state.common.goalsSearchString
  );
  const projectsSearchString = useSelector(
    (state: any) => state.actionPlan.projectsSearchString
  );
  const actionsSearchString = useSelector(
    (state: any) => state.actionPlan.actionsSearchString
  );
  const currentLibrarySearchString = useSelector((state: any) => state.library.currentLibrarySearchString);
  const archivedLibrarySearchString = useSelector((state: any) => state.library.archivedLibrarySearchString);
  const isActions = useSelector((state:any) => state.actionPlan.isActions);
  const [searchString, setSearchString] = useState("");

  useEffect(() => {
    switch (parent) {
      case "home":
        setSearchString(adminPageSearchString);
        break;
      case "evaluation":
        setSearchString(evalPageSearchString);
        break;
      case "evaluationDashboard":
        setSearchString(evalDashPageSearchString);
        break;
      case "Goals & Strategy":
        setSearchString(goalsSearchString);
        break;
      case "Performance Plan":
        isActions ? setSearchString(actionsSearchString) : setSearchString(projectsSearchString);
        break;
      case 'currentLibrary':
        setSearchString(currentLibrarySearchString);
        break;
      case 'archivedLibrary':
        setSearchString(archivedLibrarySearchString);
        break;
    }
  }, [
    parent,
    adminPageSearchString,
    evalPageSearchString,
    evalDashPageSearchString,
    goalsSearchString,
    projectsSearchString,
    actionsSearchString,
    currentLibrarySearchString,
    archivedLibrarySearchString,
  ]);

  const manageChange = (e: any, from: any) => {
    switch (from) {
      case "home":
        dispatch(setAdminPageSearchString(e?.target?.value));
        break;
      case "evaluation":
        dispatch(setEvaluationSearchString(e?.target?.value));
        break;
      case "evaluationDashboard":
        dispatch(setEvaluationDashboardSearchString(e?.target?.value));
        break;
      case "Goals & Strategy":
        dispatch(setGoalsSearchString(e?.target?.value));
        break;
      case "Performance Plan":
        isActions ? dispatch(setActionsSearchString(e?.target?.value)) : dispatch(setProjectsSearchString(e?.target?.value));
        break;
      case 'currentLibrary':
        dispatch(setCurrentLibrarySearchString(e?.target?.value));
        break;
      case 'archivedLibrary':
        dispatch(setArchivedLibrarySearchString(e?.target?.value));
        break;
    }
  };

  return (
    <React.Fragment>
      <Box>
        <Search className={searchBoxStyle} sx={{ minWidth: 320 }}>
          <SearchIconWrapper>
            <SearchIcon style={{ width: 20, color: colors.grey.dark }} />
          </SearchIconWrapper>
          <StyledInputBase
            placeholder={placeholder ? placeholder : "Search"}
            inputProps={{ "aria-label": "search" }}
            value={searchString}
            onChange={(e: any) => {
              // Update local state immediately so the 1st keystroke is never laggy
              setSearchString(e.target.value);
              manageChange(e, parent);
            }}
          />
        </Search>
        {/* <Paper sx={{ position: 'absolute', mt: 1, py: 1, minWidth: 306 }}>
                <Typography className='searchDropBox'>jhhb</Typography>
              </Paper> */}
      </Box>
    </React.Fragment>
  );
};

export default SearchBox;
